import moment from 'moment'

moment.locale('es')

class CredentialsService {
  static setUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  static getUser () {
    let user = JSON.parse(localStorage.getItem('user'))
    return user
  }

  static setPermissions (permissions) {
    localStorage.setItem('permissions', JSON.stringify(permissions))
  }

  static getPermissions () {
    let permissions = JSON.parse(localStorage.getItem('permissions'))
    return permissions
  }

  static setAuthentication (authentication) {
    localStorage.setItem('authentication', JSON.stringify(authentication))
  }

  static hasPermission (parmission) {
    const permissions = this.getPermissions()
    let index = permissions.findIndex((x) => x.name === parmission)
    return index !== -1
  }

  static getAuthentication () {
    let authentication = JSON.parse(localStorage.getItem('authentication'))
    return authentication
  }

  static getToken () {
    let authentication = JSON.parse(localStorage.getItem('authentication'))
    return authentication.access_token
  }

  static getCurrentTenantId () {
    let currentTenantId = JSON.parse(localStorage.getItem('currentTenantId'))
    return currentTenantId
  }

  static setCurrentTenantId (currentTenantId) {
    localStorage.setItem('currentTenantId', JSON.stringify(currentTenantId))
  }

  static getTenants () {
    let tenants = JSON.parse(localStorage.getItem('tenants'))
    return tenants
  }

  static setTenants (tenants) {
    localStorage.setItem('tenants', JSON.stringify(tenants))
  }

  static isAuthenticated () {
    let authentication = this.getAuthentication()
    if (authentication) {
      let expirationDate = moment(authentication.expires_at)
      let currentDate = moment()
      if (authentication.access_token && (expirationDate > currentDate)) {
        return true
      }
    }
    return false
  }

  static clearCredentials () {
    localStorage.clear('user')
    localStorage.clear('authentication')
    localStorage.clear('permissions')
  }
}

export default CredentialsService
